const plug = new Object

plug.install = (Vue)=> {
    Vue.prototype.$WxShare = function () {
        let wxcs = {
            src:'http://admin.aqitai.com/fx_logo.jpg',
            titlestr:'内蒙古阿启泰科技有限公司',
            descstr:'内蒙古阿启泰科技有限公司是由一批具专业开发技术背景的it精英所组成，年轻、富有活力，效率优先。注定一开始就是一家成熟、有效率、技术强硬的科技公司，是一家专业从事蒙汉语网站pc建设、手机网站建设、网站推广和网络营销，电子商务平台建设、app开发（android和ios）、微信公众平台建设并二次开发、服务器接口开发、域名注册网站备案、服务器租用等业务的新型技术性互联网公司。'
        }
        let urlss = window.location.href
        let yy = ''
        if(window.location.href.indexOf("/#/")!=-1){
            urlss = window.location.href.substring(0,window.location.href.indexOf("/#/"))
            yy = window.location.href.substring(window.location.href.indexOf("/#/"))
        }else{
            if(window.location.href.indexOf("/?")!=-1){
                urlss = window.location.href.substring(0,window.location.href.indexOf("/?"))
                yy = window.location.href.substring(window.location.href.indexOf("/?"))
            }
        }
        let shareWxLink = window.location.origin + '/redirect.html?app3Redirect=' + encodeURIComponent(urlss+yy)
        if(window.Vm) {
            Vm.wx.ready(function () {
                // 分享给朋友
                Vm.wx.onMenuShareAppMessage({
                    title: wxcs.titlestr,
                    desc: wxcs.descstr,
                    link: shareWxLink,
                    imgUrl: wxcs.src,
                    success: function () {
                       alert("分享成功");
                    },
                });
                // 分享到朋友圈
                Vm.wx.onMenuShareTimeline({
                    title: wxcs.titlestr,
                    link: shareWxLink,
                    imgUrl: wxcs.src,
                    success: function () {
                        alert("分享成功");
                    },
                });
            });
        }

    }
}
export default plug
